export default __webpack_public_path__ + "static/media/explore5.8b3ac709.png";